import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import notify from '../../utils/notify';

const initialState = {
    isLoading: false,
    userData: null,
    nftData: null,
};

export const getProfile = createAsyncThunk('userProfile', (data, thunkAPI) => {
    const response = axiosInstance
        .get(endpoints.userProfile)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return thunkAPI.rejectWithValue(error);
        });
    return response;
});

const profileSlice = createSlice({
    name: 'userProfile',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProfile.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getProfile.fulfilled, (state, action) => {
            const userData = action.payload.result;
            const nftDAta = action.payload.result.nft;
            delete userData.nft;
            delete userData.password;
            state.userData = userData;
            state.nftData = nftDAta;
            state.isLoading = false;
        });
        builder.addCase(getProfile.rejected, (state, action) => {
            state.isLoading = false;
            notify(action.payload?.response?.data?.Message);
        });
    },
});

export default profileSlice.reducer;
